import React from 'react';
import { Link } from 'react-router-dom';
import { useMessageNotifications } from '../../contexts/MessageNotificationContext';

const DROPDOWN_ID = 'messagesDropdown';
const MAX_ITEMS = 20;

function formatRelativeTime(iso: string | null): string {
  if (!iso) return '';
  const ts = Date.parse(iso);
  if (Number.isNaN(ts)) return '';
  const diffMs = Date.now() - ts;
  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 1) return 'şimdi';
  if (diffMin < 60) return `${diffMin} dk`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `${diffH} sa`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 7) return `${diffD} gün`;
  return new Date(ts).toLocaleDateString('tr-TR');
}

const MessageCenterDropdown: React.FC = () => {
  const { messageUnreadCount, conversationSummaries, markConversationRead } =
    useMessageNotifications();

  const items = conversationSummaries.slice(0, MAX_ITEMS);

  return (
    <div className="dropdown position-relative me-2">
      <button
        type="button"
        className="btn btn-link text-primary dropdown-toggle d-flex align-items-center border-0 position-relative"
        style={{ textDecoration: 'none', fontWeight: 'normal' }}
        id={DROPDOWN_ID}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label="Mesajlar"
      >
        <i className="fas fa-envelope fs-5" />
        {messageUnreadCount > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill text-primary"
            style={{ border: '1px solid #0d6efd', backgroundColor: 'var(--sb-bg)' }}
          >
            {messageUnreadCount}
          </span>
        )}
      </button>
      <ul
        className="dropdown-menu dropdown-menu-end p-0"
        aria-labelledby={DROPDOWN_ID}
        style={{ borderTop: '3px solid #0d6efd', minWidth: '320px', maxWidth: '380px' }}
      >
        <li>
          <h6 className="dropdown-header bg-primary text-white m-0 px-3 py-2">Mesajlar</h6>
        </li>
        {items.length === 0 ? (
          <li>
            <div className="px-3 py-3 text-muted small text-center">Henüz mesaj yok.</div>
          </li>
        ) : (
          items.map((s) => (
            <li key={s.conversationId}>
              <Link
                to={`/mesajlar?conversationId=${s.conversationId}`}
                className="dropdown-item px-3 py-2 d-flex flex-column"
                onClick={() => {
                  void markConversationRead(s.conversationId);
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span
                    className="fw-semibold text-truncate"
                    style={{ maxWidth: '220px' }}
                    title={s.peerDisplayName}
                  >
                    {s.peerDisplayName}
                  </span>
                  <small className="text-muted ms-2">{formatRelativeTime(s.lastMessageAt)}</small>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-1">
                  <small
                    className="text-muted text-truncate"
                    style={{ maxWidth: '260px' }}
                    title={s.lastMessagePreview ?? ''}
                  >
                    {s.lastMessagePreview ?? ''}
                  </small>
                  {s.unreadMessageCount > 0 && (
                    <span className="badge rounded-pill bg-primary ms-2">
                      {s.unreadMessageCount}
                    </span>
                  )}
                </div>
              </Link>
            </li>
          ))
        )}
        <li>
          <div className="dropdown-divider m-0" />
        </li>
        <li>
          <Link to="/mesajlar" className="dropdown-item text-center text-primary fw-semibold py-2">
            Tüm Mesajları Görüntüle
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default MessageCenterDropdown;
